import EventActionProto from '../event-action-proto'
import {SESSION_PROJECT_USERS_CHANGED, SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import Session_reinitNavigationStructure from "../functions/reinit-navigation-structure"
// import SessionLoader from "../../gd/data/session-loader";

module.exports = class EventProjectsAndUsersReset extends EventActionProto {

    constructor(uid, data, sid, companyId) {
        super(uid, data, companyId);
    }

    process() {

        // akkuratno mi shlem etot event i posle full reset
        // when delete project user
        if (gd.companyId && this.isDifferentCompany()) {
            // console.log("diff. company -> igore");
            return false;
        }

        // akkuratno see projets reset i project users reset as this methodn combines both

        // if current app is project app settings transfer is required
        let relatedProjects = [],savedProjectsSettings = {};
        if (!!gd.app && !!gd.app.projectId) {
            const parentProjectsIds = gd.session.projects.getAllParents(gd.app.projectId).map(p=>p.id);
            const childrenProjectsIds = gd.session.projects.getAllChildren(gd.app.projectId).map(p=>p.id);
            relatedProjects = _.union(parentProjectsIds, childrenProjectsIds, [gd.app.projectId]);

            _.map(relatedProjects, projectId=>{
                const project = gd.session.projects.get(projectId);
                if (project) savedProjectsSettings[projectId] = project.settings;
            })
        }

        gd.session.projects.resetAndKeepOldModels(this.data.projects)
        gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)

        // restore previously saved settings
        _.map(relatedProjects, projectId=>{
            const project = gd.session.projects.get(projectId);
            if (project && savedProjectsSettings[projectId]) project.settings = savedProjectsSettings[projectId];
        })

        gd.tree.companies.map(company=>{
            gd.tree.resetCompanyProjects(company.id)
        })

        // OK teper' project users
        gd.session.projectUsers.resetAndKeepOldModels(this.data.projectUsers)

        Session_reinitNavigationStructure()
        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)
    }
};